import React from "react";
import PropTypes from "prop-types";
import { animateScroll as scroll } from "react-scroll";

import Icon from "components/Icon";
import dayjs from "dayjs"

const RELEASE_DAY = '2023-11-23'

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const handleScrollingTo = (position) => {
  scroll.scrollTo(position, { delay: 0, smooth: "linear", duration: 600 });
};

export const SliderNextArrow = ({ className, onClick }) => (
  <button
    className={`top-[50%] right-[-60px] h-12 w-12 before:content-none ${className}`}
    onClick={onClick}
  >
    <Icon name={"next"} size={48} />
  </button>
);

export const SliderPrevArrow = ({ className, onClick }) => (
  <button
    className={`top-[50%] left-[-60px] h-12 w-12 before:content-none ${className}`}
    onClick={onClick}
  >
    <Icon name={"previous"} size={48} />
  </button>
);

export const registerEnabled = () => {
  return dayjs().isBefore(dayjs(new Date(RELEASE_DAY), 'day'))
}

SliderNextArrow.propTypes = {
  onClick: PropTypes.func,
};

SliderPrevArrow.propTypes = {
  onClick: PropTypes.func,
};
